import { FONT_REGULAR } from '../../constants/AppConstants';

export default class LoadBar extends Phaser.Group {
  constructor(game) {
    super(game);

    // backing panel
    this.backing = this.game.make.graphics();
    this.backing.beginFill(0x000000, 0.2);
    this.backing.drawRoundedRect(0, 0, 200, 20, 10);
    this.addChild(this.backing);

    // fill bar
    this.fill = this.game.make.graphics();
    this.fill.beginFill(0x775e93);
    this.fill.drawRoundedRect(0, 0, 200, 20, 10);
    this.addChild(this.fill);

    this.masker = this.game.make.graphics();
    this.masker.beginFill(0xff0000);
    this.masker.drawRect(0, 0, 200, 20);
    this.addChild(this.masker);

    this.fill.mask = this.masker;

    // add loading text
    this.copy = this.game.add.text(0, 0, this.game.copy.getCopy('loading') + ' 0%', {
      font: '47px ' + FONT_REGULAR,
      fill: '#775e93',
      boundsAlignH: 'center',
    });

    this.copy.setTextBounds(-50, -90, 300);
    this.addChild(this.copy);
    this.setProgress(0);
  }

  get width() {
    return this.backing.width;
  }

  get height() {
    return this.backing.height;
  }

  setProgress(value) {
    this.masker.clear();
    this.masker.beginFill(0xff0000);
    this.masker.drawRect(0, 0, this.fill.width * value, 20);
    const percent = Math.round(value * 100);
    this.copy.text = this.game.copy.getCopy('loading') + ' ' + percent + '%';
  }

  setProcessing() {
    this.copy.text = this.game.copy.getCopy('processing');
  }

  destroy(destroyChildren = true, soft = false) {
    // destroy
    this.copy.destroy();
    this.backing.destroy();
    this.fill.destroy();
    this.masker.destroy();

    // clean
    this.backing = null;
    this.fill = null;
    this.masker = null;
    this.copy = null;
    super.destroy(destroyChildren, soft);
  }
}
